import { lazy, StrictMode, Suspense } from "react"
import { createRoot } from "react-dom/client"
import { Button, ThemeProvider } from "@florisoft/ui"

import { BootProgress } from "./boot-progress"
import { ErrorBoundary, FailureAlert } from "./error-boundary"
import "./app.css"

// The shell and its progress appear first; the designer and the runtime load behind them.
const App = lazy(() => import("./App"))

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider storageKey="florisoft-prototyper-theme">
      <ErrorBoundary
        fallback={({ error, retry }) => (
          <FailureAlert title="Prototyper failed" error={error}>
            <Button onClick={retry}>Retry</Button>
            <Button variant="ghost" onClick={() => window.location.reload()}>
              Reload
            </Button>
          </FailureAlert>
        )}
      >
        <Suspense
          fallback={<BootProgress title="Starting the Prototyper" stage="Loading the designer and the runtime." />}
        >
          <App />
        </Suspense>
      </ErrorBoundary>
    </ThemeProvider>
  </StrictMode>
)
